import { CaretLeftOutlined } from '@ant-design/icons';
import { FC } from 'react';
import Wrap from './styles';

type Props = {
  backToPrev: () => void;
};

const backToStepPrevBillDetail: FC<Props> = ({ backToPrev }) => {
  return (
    <Wrap>
      <div onClick={backToPrev} className="box">
        <CaretLeftOutlined className="icon" />
        <p className="standardFont mb-0 text">請求書一覧に戻る</p>
      </div>
    </Wrap>
  );
};

export default backToStepPrevBillDetail;
